<span *ngIf="imageSource">
  <img class="barcode-container" [src]="imageSource">
</span>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-barcode/request-barcode.component.html